import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card } from './ui/card';
import portfolioData from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={portfolioData.images.aboutSection}
                alt="Agriculture professional"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-yellow-600 rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-olive-600 rounded-2xl -z-10"></div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h2 className="text-4xl lg:text-5xl font-bold text-stone-900 leading-tight">
                Acerca de Mí
              </h2>
              <p className="text-lg text-stone-700 leading-relaxed">
                {portfolioData.about.description}
              </p>
              <p className="text-lg text-stone-700 leading-relaxed">
                {portfolioData.about.mission}
              </p>
            </div>

            {/* Highlights */}
            <Card className="p-8 bg-white border-stone-200 shadow-lg">
              <h3 className="text-2xl font-bold text-stone-900 mb-6">
                Logros Destacados
              </h3>
              <div className="space-y-4">
                {portfolioData.about.highlights.map((highlight, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle size={20} className="text-yellow-600 mt-1 flex-shrink-0" />
                    <p className="text-stone-700 leading-relaxed">{highlight}</p>
                  </div>
                ))}
              </div>
            </Card>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-6 bg-olive-600 rounded-xl text-white">
                <div className="text-3xl font-bold mb-2">37+</div>
                <div className="text-sm uppercase tracking-wider">Años de Experiencia</div>
              </div>
              <div className="text-center p-6 bg-yellow-600 rounded-xl text-stone-900">
                <div className="text-3xl font-bold mb-2">250K+</div>
                <div className="text-sm uppercase tracking-wider">Toneladas Gestionadas</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;